import { render, staticRenderFns } from "./ViAcceptInvation.vue?vue&type=template&id=b8c50b6a&scoped=true"
import script from "./ViAcceptInvation.vue?vue&type=script&lang=js"
export * from "./ViAcceptInvation.vue?vue&type=script&lang=js"
import style0 from "./ViAcceptInvation.vue?vue&type=style&index=0&id=b8c50b6a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c50b6a",
  null
  
)

export default component.exports